import { differenceInDays } from 'date-fns'

import { COMPLETE_TRIAL_REQUEST_WINDOW_DAYS } from './constants'

const STORAGE_KEY_PREFIX = 'vt_complete_trial_requested_'

export function completeTrialRequestedStorageKey(companyId: string): string {
  return `${STORAGE_KEY_PREFIX}${companyId}`
}

/** Read before localStorage.clear() and re-set after, so logging out doesn't bring the link back. */
export function collectCompleteTrialRequestStorage(): [string, string][] {
  const entries: [string, string][] = []
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      const companyId = key?.startsWith(STORAGE_KEY_PREFIX) ? key.slice(STORAGE_KEY_PREFIX.length) : null
      const value = companyId && isCompleteTrialRequested(companyId) ? localStorage.getItem(key as string) : null
      if (key && value) entries.push([key, value])
    }
  } catch {
    // no-op
  }
  return entries
}

export function isCompleteTrialRequested(companyId: string | undefined): boolean {
  if (!companyId) return false
  try {
    const requestedAt = localStorage.getItem(completeTrialRequestedStorageKey(companyId))
    if (!requestedAt) return false
    const days = differenceInDays(new Date(), new Date(requestedAt))
    return days >= 0 && days < COMPLETE_TRIAL_REQUEST_WINDOW_DAYS
  } catch {
    return false
  }
}

export function markCompleteTrialRequested(companyId: string): void {
  try {
    localStorage.setItem(completeTrialRequestedStorageKey(companyId), new Date().toISOString())
  } catch {
    // ignore quota / private mode
  }
}
